import React, { useState, useEffect } from "react";
import { Navbar } from "react-bootstrap";
import { isMobileOrTablet } from "../Utils";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import HomeUserWayAccessibilityMenu from "../HomeUserWayAccessibilityMenu/homeUserWayAccessibility";
import RigVedQuotes from "../HomeRigvedQuotes/rigvedQuotes";
import AngelAiHeader from "../AngelAiHeader/AngelAiHeader";

import "../HomeHeader/homeheader.css";
import "../LoHeader/LoHeader.css";
import "../InfluencerHeader/InfluencerHeader.css";

const isAngelAi = process.env.REACT_APP_DOMAIN === "angelai";

const HEADER_CONFIG = {
  main: {
    navbarId: "menuNavbar",
    navbarClass: "navbar",
    logoClass: "main_logo img-fluid",
    angelaiLogoClass: "angelai-logo",
    taglineContainerClass: "tagline-container",
    taglineClass: "brand-tagline",
    angelaiContainerClass: "angelai-section",
    headerRightClass: "header-right-section",
    AccessibilityMenu: HomeUserWayAccessibilityMenu,
    useHeaderRightLayout: true,
  },
  mlo: {
    navbarId: "loanOfficerNavbar",
    navbarClass: "loanOfficerNavbar",
    logoClass: "loan_officer_logo",
    angelaiLogoClass: "loan-officer-angelai-logo",
    taglineContainerClass: "loan-officer-tagline-container",
    taglineClass: "loan-officer-tagline",
    angelaiContainerClass: "angelai-logo-container",
    AccessibilityMenu: UserWayAccessibilityMenu,
    useHeaderRightLayout: false,
  },
  influencer: {
    navbarId: "influencerNavbar",
    navbarClass: "influencerNavbar",
    logoClass: "influencer_logo",
    angelaiLogoClass: "influencer-angelai-logo",
    taglineContainerClass: "influencer-tagline-container",
    taglineClass: "influencer-tagline",
    angelaiContainerClass: "angelai-logo-container",
    AccessibilityMenu: UserWayAccessibilityMenu,
    useHeaderRightLayout: false,
  },
};

const MastermindsHeader = ({ pageType = "main" }) => {
  const [navbar, setNavbar] = useState(false);
  const [showRigVedQuotes, setShowRigVedQuotes] = useState(false);
  const isMobileOrTabletDevice = isMobileOrTablet();
  const config = HEADER_CONFIG[pageType] || HEADER_CONFIG.main;
  const AccessibilityMenu = config.AccessibilityMenu;

  useEffect(() => {
    let prevScrollPos = window.scrollY;

    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      const menuNavbar = document.getElementById(config.navbarId);

      if (currentScrollPos === 0) {
        menuNavbar?.classList.remove("navbarTransition");
        setNavbar(false);
      } else if (prevScrollPos > currentScrollPos) {
        setNavbar(true);
      } else if (prevScrollPos < currentScrollPos) {
        if (!isMobileOrTabletDevice) {
          setNavbar(true);
        } else {
          setNavbar(false);
          menuNavbar?.classList.add("navbarTransition");
          setShowRigVedQuotes(false);
        }
      }
      prevScrollPos = currentScrollPos;
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [config.navbarId, isMobileOrTabletDevice]);

  if (isAngelAi) return <AngelAiHeader />;

  const logoSection = (
    <a href="https://www.swmc.com/" target="_blank" rel="noopener noreferrer" title="Sun West Mortgage Logo">
      <img
        src={`${process.env.REACT_APP_CDN_LINK}swmc-images/Homepage/New/SunWest41YearsofTrust-White.svg`}
        className={config.logoClass}
        alt="Sun West Logo"
      />
    </a>
  );

  const angelaiLogo = (
    <img
      src={`${process.env.REACT_APP_CDN_LINK}angel-ai/latest-angelai-logo.webp`}
      className={config.angelaiLogoClass}
      alt="AngelAi Logo"
    />
  );

  const tagline = (
    <div className={config.taglineContainerClass}>
      <p
        className={config.taglineClass}
        onClick={() => setShowRigVedQuotes(true)}
        onMouseOver={() => setShowRigVedQuotes(true)}
        onMouseOut={() => setShowRigVedQuotes(false)}
      >
        Nothing Is Beyond Reach
      </p>
      <RigVedQuotes showRigVedQuotes={showRigVedQuotes} />
    </div>
  );

  if (config.useHeaderRightLayout) {
    return (
      <div>
        <Navbar
          id={config.navbarId} collapseOnSelect expand="lg" fixed="top" bg="dark" variant="dark"
          className={navbar ? `${config.navbarClass} active` : config.navbarClass}
        >
          <Navbar.Brand>{logoSection}</Navbar.Brand>
          <div className={config.headerRightClass}>
            <div className={config.angelaiContainerClass}>
              <a href="https://www.angelai.com/" target="_blank" rel="noopener noreferrer">{angelaiLogo}</a>
              {tagline}
            </div>
            <AccessibilityMenu color="white" width={40} height={40} />
          </div>
        </Navbar>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        id={config.navbarId} collapseOnSelect expand="lg" fixed="top" bg="dark" variant="dark"
        className={navbar ? `${config.navbarClass} active` : config.navbarClass}
      >
        <Navbar.Brand className="ps-3">
          <div className="d-flex"><div>{logoSection}</div></div>
          <div className="desktop-AccessibilityMenu-show1">
            <AccessibilityMenu color="white" width={40} height={40} />
          </div>
        </Navbar.Brand>
        <div className="mobile-AccessibilityMenu-show1">
          <AccessibilityMenu color="white" width={40} height={40} />
        </div>
        <a href="https://www.angelai.com/" target="_blank" rel="noopener noreferrer" className={config.angelaiContainerClass}>
          {angelaiLogo}
        </a>
        {tagline}
      </Navbar>
    </div>
  );
};

export default MastermindsHeader;
